import { Input, Select } from "antd";
import React, { useContext } from "react";
import { TimeTrackingUserDataContext } from "../../../../TimeTrackingUserDataProvider";
import { EditSessionModalContext } from "./types";

const Dot: React.FC<{ color: string }> = ({ color }) => (
  <span
    style={{
      display: "inline-block",
      width: 10,
      height: 10,
      borderRadius: "50%",
      backgroundColor: color,
      flexShrink: 0,
    }}
  />
);

const CalendarTaskInput = () => {
  const { formData, setFormData } = useContext(EditSessionModalContext);
  const { projects } = useContext(TimeTrackingUserDataContext);

  const selectedProject = projects.find(
    (p) => p.projectId === formData.projectId,
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {/* Description */}
      <Input
        style={{
          border: "1px solid #e8e8e8",
          borderRadius: 6,
          fontSize: 15,
          fontWeight: 500,
          padding: "8px 12px",
        }}
        placeholder="What were you working on?"
        value={formData.description}
        onChange={(e) =>
          setFormData((prev) => ({ ...prev, description: e.target.value }))
        }
        maxLength={3000}
      />

      {/* Project select */}
      <Select
        style={{ width: "100%", borderRadius: 6 }}
        value={formData.projectId || undefined}
        placeholder={
          <span style={{ color: "#aaa", fontSize: 14 }}>Select project</span>
        }
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, projectId: value }))
        }
        dropdownMatchSelectWidth={false}
        optionLabelProp="label"
        suffixIcon={
          selectedProject ? <Dot color={selectedProject.color} /> : undefined
        }
      >
        {projects.map((p) => (
          <Select.Option
            key={p.projectId}
            value={p.projectId}
            label={
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <Dot color={p.color} />
                <span style={{ color: p.color, fontWeight: 600, fontSize: 14 }}>
                  {p.projectName}
                </span>
              </span>
            }
          >
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Dot color={p.color} />
              <span style={{ color: p.color, fontWeight: 600 }}>
                {p.projectName}
              </span>
            </span>
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
export default CalendarTaskInput;
